import {useState} from 'react';
// @ts-expect-error
import type {Control} from 'react-hook-form';

import {Button} from 'shells/button/button';
import {Stack} from 'shells/layout/stack/stack';
import {Body} from 'shells/typography/body';

import type {MultiPageForm} from '../../../types';

import {AddableFieldCard} from './addable-field-card';
import {CONTENT_BLOCKS} from './consts';
import {NutshellFieldsSection} from './nutshell-fields-section';
import type {FieldDef} from './types';

import styles from './content-blocks-tab.module.css';

interface Props {
    control: Control<MultiPageForm>;
}

export function ContentBlocksTab(props: Props) {
    const [showNutshellFields, setShowNutshellFields] = useState<boolean>(false);

    return (
        <Stack spacing={16}>
            <Body>Drag and drop content blocks to your form</Body>
            <div className={styles['grid']}>
                {CONTENT_BLOCKS.map((field: FieldDef) => (
                    <AddableFieldCard
                        key={field.label}
                        id={`block:${field.label}`}
                        icon={field.icon}
                        label={field.label}
                        dragData={field.dragData}
                    />
                ))}
            </div>
            <Button variant='upgrade' onClick={() => setShowNutshellFields((prev) => !prev)}>
                {showNutshellFields ? 'Hide Nutshell fields' : 'See more Nutshell fields'}
            </Button>
            {showNutshellFields && <NutshellFieldsSection control={props.control} />}
        </Stack>
    );
}
